import React from "react";
import { Flex, Box } from "grid-styled";

import { SlimLink, Relative } from "../globals";
import Icon from "../Icon";

const PurchaseLinks = ({ book }) => (
    <Flex>
        <Relative top={1}>
            <SlimLink
                href={book.amazonLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Icon glyph="amazon" size={24} />
            </SlimLink>
        </Relative>
        {book.goodreadsLink ? (
            <Box ml={4}>
                <SlimLink
                    href={book.goodreadsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon glyph="goodreads" size={24} />
                </SlimLink>
            </Box>
        ) : null}
        {book.audibleLink ? (
            <Box ml={4}>
                <SlimLink
                    href={book.audibleLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon glyph="audible" size={24} />
                </SlimLink>
            </Box>
        ) : null}
    </Flex>
);

export default PurchaseLinks;



// WEBPACK FOOTER //
// ./src/components/PurchaseLinks/index.js